"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortRoster = void 0;
var immutable_1 = require("../utils/immutable");
function sortRoster(data) {
    var rooms = data.rooms, inSortMoratorium = data.inSortMoratorium, respectSortMoratorium = data.respectSortMoratorium, joinedRooms = data.joinedRooms;
    if ((respectSortMoratorium && !inSortMoratorium) || !respectSortMoratorium) {
        var sortedRooms = sortRooms(rooms, joinedRooms);
        return sortedRooms;
    }
    else {
        return rooms;
    }
}
exports.sortRoster = sortRoster;
function sortRooms(rooms, joinedRooms) {
    var rooms0 = immutable_1.orderedMapSort(rooms, function (a, b) {
        if (a.id && b.id) {
            return a.id.localeCompare(b.id);
        }
        else {
            return 0;
        }
    });
    var res = immutable_1.orderedMapSort(rooms0, function (a, b) {
        /*
            Scoring:
            41+ -- room is open
            11+ -- higher badge last_ts
             3+ -- higher interaction_ts

             if equal: localCompare names
        */
        var aScore = 0;
        var bScore = 0;
        /* open rooms */
        aScore = a.id && joinedRooms.includes(a.id) ? aScore + 41 : aScore;
        bScore = b.id && joinedRooms.includes(b.id) ? bScore + 41 : bScore;
        /* higher badge last_ts */
        aScore =
            ((a.badge && a.badge.last_ts) || 0) > ((b.badge && b.badge.last_ts) || 0)
                ? aScore + 11
                : aScore;
        bScore =
            ((b.badge && b.badge.last_ts) || 0) > ((a.badge && a.badge.last_ts) || 0)
                ? bScore + 11
                : bScore;
        /* interaction_ts */
        aScore = (a.interaction_ts || 0) > (b.interaction_ts || 0) ? aScore + 3 : aScore;
        bScore = (b.interaction_ts || 0) > (a.interaction_ts || 0) ? bScore + 3 : bScore;
        if (aScore === bScore) {
            if (a.name && b.name) {
                return a.name.localeCompare(b.name);
            }
            else if (a.name) {
                return -1;
            }
            else if (b.name) {
                return 1;
            }
            else {
                return 0;
            }
        }
        else if (aScore > bScore) {
            return -1;
        }
        else {
            return 1;
        }
    });
    return res;
}
